import React from 'react';
import Modal from '../ui/Modal';
import { User, Trophy } from 'lucide-react';

interface AnalyticsListModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    type: 'staff' | 'services';
    data: any[];
}

const AnalyticsListModal: React.FC<AnalyticsListModalProps> = ({ isOpen, onClose, title, type, data }) => {

    if (!isOpen) return null;

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            headerContent={
                <div>
                    <h2 className="text-xl font-bold text-gray-900">{title}</h2>
                    <p className="text-sm text-gray-500 mt-1">
                        {type === 'staff' ? 'Classifica completa fatturato' : 'Lista completa servizi eseguiti'}
                    </p>
                </div>
            }
        >
            <div className="space-y-3 pb-6">
                {data.map((item, idx) => (
                    <div
                        key={idx}
                        className="flex items-center justify-between p-4 rounded-xl border border-gray-100 hover:bg-gray-50 transition-colors bg-white shadow-sm"
                    >
                        <div className="flex items-center gap-4">
                            {/* Icona / Posizione */}
                            <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm shrink-0
                                ${idx === 0
                                    ? 'bg-amber-100 text-amber-600 border border-amber-200'
                                    : idx === 1
                                        ? 'bg-gray-200 text-gray-600 border border-gray-300'
                                        : idx === 2
                                            ? 'bg-orange-100 text-orange-700 border border-orange-200'
                                            : 'bg-gray-50 text-gray-500 border border-gray-100'
                                }`}
                            >
                                {idx < 3 ? <Trophy size={16} /> : idx + 1}
                            </div>

                            {/* Info */}
                            <div>
                                <h4 className="font-bold text-gray-900 text-sm">{item.name}</h4>
                                <p className="text-xs text-gray-500">
                                    {type === 'staff' ? 'Collaboratore' : `${item.rawValue} eseguiti`}
                                </p>
                            </div>
                        </div>

                        {/* Valore */}
                        <div className="text-right">
                            <span className="block font-bold text-gray-900 text-lg">
                                {type === 'staff'
                                    ? `€ ${item.revenue.toLocaleString()}`
                                    : `${item.value}%`
                                }
                            </span>
                            {type === 'services' && (
                                <span className="text-xs text-gray-400">del totale</span>
                            )}
                        </div>
                    </div>
                ))}

                {data.length === 0 && (
                    <div className="text-center text-gray-400 py-10">
                        Nessun dato disponibile
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default AnalyticsListModal;